import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["height", "width", "size", "className", "style", "children"],
  _excluded2 = ["base", "className", "style", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getSpacing } from "@faire/web--source/slate/spacing/getSpacing";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import cn from "classnames";
import React from "react";
import { isResponsiveProp } from "../Theme/ResponsiveProp";
import * as styles from "./styles.css";
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/component/spacer/web/spacer)
 */
export var Spacer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref2;
  var heightProp = _ref.height,
    widthProp = _ref.width,
    sizeProp = _ref.size,
    className = _ref.className,
    styleProp = _ref.style,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var flexBasis;
  var minWidth;
  var minHeight;
  var width;
  var height;
  var vars = {};
  var definedSize = (_ref2 = sizeProp !== null && sizeProp !== void 0 ? sizeProp : widthProp) !== null && _ref2 !== void 0 ? _ref2 : heightProp;
  if (definedSize != null) {
    var staticSize;
    if (isResponsiveProp(definedSize)) {
      vars[styles.sizeVar] = getSpacing(definedSize.mobileAndAbove);
      vars[styles.sizeTabletVar] = definedSize.tabletAndAbove != null ? getSpacing(definedSize.tabletAndAbove) : undefined;
      vars[styles.sizeDesktopVar] = definedSize.desktopAndAbove != null ? getSpacing(definedSize.desktopAndAbove) : undefined;
      vars[styles.sizeXLargeVar] = definedSize.xLargeAndAbove != null ? getSpacing(definedSize.xLargeAndAbove) : undefined;
      vars[styles.sizeXXLargeVar] = definedSize.xxLargeDesktop != null ? getSpacing(definedSize.xxLargeDesktop) : undefined;
      staticSize = {
        mobileAndAbove: styles.sizeVar,
        tabletAndAbove: definedSize.tabletAndAbove != null ? styles.sizeTabletVar : undefined,
        desktopAndAbove: definedSize.desktopAndAbove != null ? styles.sizeDesktopVar : undefined,
        xLargeAndAbove: definedSize.xLargeAndAbove != null ? styles.sizeXLargeVar : undefined,
        xxLargeDesktop: definedSize.xxLargeDesktop != null ? styles.sizeXXLargeVar : undefined
      };
      flexBasis = staticSize;
    } else {
      vars[styles.sizeVar] = getSpacing(definedSize);
      flexBasis = styles.sizeVar;
      staticSize = styles.sizeVar;
    }
    if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : widthProp) != null) {
      minWidth = staticSize;
    }
    if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : heightProp) != null) {
      minHeight = staticSize;
    }
    if (widthProp) {
      height = 0;
    } else if (heightProp) {
      width = 0;
    }
  }
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    ref: ref,
    style: _objectSpread(_objectSpread({}, assignInlineVars(vars)), styleProp),
    className: cn(className, styles.spacerBase, styles.sprinkles({
      flexBasis: flexBasis,
      minWidth: minWidth,
      minHeight: minHeight,
      width: width,
      height: height
    }))
  }, rest), children);
});
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/component/spacer/web/growing-spacer)
 */
export var GrowingSpacer = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var sizeProp = _ref3.base,
    className = _ref3.className,
    styleProp = _ref3.style,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  var flexBasis;
  var vars = {};
  if (sizeProp != null) {
    if (isResponsiveProp(sizeProp)) {
      vars[styles.sizeVar] = getSpacing(sizeProp.mobileAndAbove);
      vars[styles.sizeTabletVar] = sizeProp.tabletAndAbove != null ? getSpacing(sizeProp.tabletAndAbove) : undefined;
      vars[styles.sizeDesktopVar] = sizeProp.desktopAndAbove != null ? getSpacing(sizeProp.desktopAndAbove) : undefined;
      vars[styles.sizeXLargeVar] = sizeProp.xLargeAndAbove != null ? getSpacing(sizeProp.xLargeAndAbove) : undefined;
      vars[styles.sizeXXLargeVar] = sizeProp.xxLargeDesktop != null ? getSpacing(sizeProp.xxLargeDesktop) : undefined;
      flexBasis = {
        mobileAndAbove: styles.sizeVar,
        tabletAndAbove: sizeProp.tabletAndAbove != null ? styles.sizeTabletVar : undefined,
        desktopAndAbove: sizeProp.desktopAndAbove != null ? styles.sizeDesktopVar : undefined,
        xLargeAndAbove: sizeProp.xLargeAndAbove != null ? styles.sizeXLargeVar : undefined,
        xxLargeDesktop: sizeProp.xxLargeDesktop != null ? styles.sizeXXLargeVar : undefined
      };
    } else {
      vars[styles.sizeVar] = getSpacing(sizeProp);
      flexBasis = styles.sizeVar;
    }
  }
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    ref: ref,
    style: _objectSpread(_objectSpread({}, assignInlineVars(vars)), styleProp),
    className: cn(className, styles.growingSpacerBase, styles.sprinkles({
      flexBasis: flexBasis
    }))
  }, rest), children);
});